import { TextField as MuiTextField } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { ColSpan } from '../types';
import { generateColSpan } from '../utils';

interface TextFieldProps {
  $colspan?: ColSpan;
  $absoluteHelperText?: boolean;
  $hideHelperText?: boolean;
}

export const TextField = styled(MuiTextField)<TextFieldProps>`
  ${({ $colspan, $absoluteHelperText, $hideHelperText }) => css`
    ${$colspan ? generateColSpan($colspan) : ''}
    ${
      $absoluteHelperText &&
      css`
        & .MuiFormHelperText-root {
          position: absolute;
          bottom: 0;

          transform: translateY(100%);
          font-size: 10px;
        }
      `
    }


      ${
        $hideHelperText &&
        css`
          & .MuiFormHelperText-root {
            display: none;
          }
        `
      }
  `}
`;

export const InputDateContainer = styled.div<{ $colspan?: ColSpan }>`
  ${({ $colspan, theme }) => css`
    & ::-webkit-calendar-picker-indicator {
      filter: ${theme.palette.type === 'light' ? 'invert(0)' : 'invert(100%)'};
    }
    ${$colspan ? generateColSpan($colspan) : ''}
  `}
`;
